


































































































































import { Component, Vue } from 'vue-property-decorator';
import { IExternalLinks, IExternalLinksCreate, IImageExternalLinks, IPreviewExternalLinks } from '@/interfaces';
import { dispatchCreateExternalLink, dispatchGetExternalLinks } from '@/store/externalLinks/actions';
import Upload from '@/components/UploadMultipleImage/Upload.vue';
import { FieldError } from 'vee-validate';

@Component({
  components: {
    Upload,
  },
})
export default class CreateExternalLink extends Vue {
  public valid = false;
  public setPreview = false;
  public title: string = '';
  public code: string = '';
  public text: string = '';
  public templateIcon: IImageExternalLinks | null = null;
  public templateImage: IImageExternalLinks | null = null;
  public url: string = '';
  public preview: IPreviewExternalLinks = {
    enable: false,
    text: '',
    image: null,
    button_text: 'Ingresar',
  };

  public async mounted() {
    await dispatchGetExternalLinks(this.$store);
    this.reset();
  }

  public reset() {
    this.title = '';
    this.code = '';
    this.url = '';
    this.text = '';
    this.templateIcon = null;
    this.templateImage = null;
    this.preview = {
      enable: false,
      text: '',
      image: null,
      button_text: 'Ingresar',
    };
    this.$validator.reset();
  }

  public cancel() {
    this.$router.back();
  }

  public async submit() {
    if (this.setPreview && this.preview.text === '' && this.preview.image === null) {
      this.$validator.validateAll();
      const error: FieldError = {
        field: 'preview_missing',
        msg: 'Alguno de los dos campos [Imagen Previsualización] o [Texto Previsualización] deben tener valor para continuar',
      };
      this.$validator.errors.add(error);
      return;
    }
    if (await this.$validator.validateAll()) {
      const createdLink: IExternalLinksCreate = {
        code: this.code,
        title: this.title,
        url: this.url,
        template_icon: this.templateIcon,
        template_image: this.templateImage,
        preview: {
          enable: this.preview.enable,
          text: this.preview.text,
          image: this.preview.image,
          button_text: this.preview.button_text,
        },
      };
      await dispatchCreateExternalLink(this.$store, createdLink);
    }
  }

  // asigna el objeto imagen devuelto por la api
  public onImageUploadedIcon(response) {
    this.templateIcon = response.data;
  }
  public onImageUploadedImage(response) {
    this.templateImage = response.data;
  }
  public onImageUploadedPreview(response) {
    this.preview.image = response.data;
  }
  public tooglePreviewEnabled(value) {
    this.preview.enable = value;
  }
  public onTemplateIconRemoved() {
    this.templateIcon = null;
  }
  public onTemplateImageRemoved() {
    this.templateImage = null;
  }
  public onPreviewImageRemoved() {
    this.preview.image = null;
  }
}
